"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = lastOf;
function lastOf(array) {
  return array === null || array === void 0 ? void 0 : array[array.length - 1];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJsYXN0T2YiLCJhcnJheSIsImxlbmd0aCJdLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3Byb3ZpZGVycy9BY3Rpdml0eUtleWVyL3ByaXZhdGUvbGFzdE9mLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIGxhc3RPZjxUPihhcnJheTogcmVhZG9ubHkgVFtdIHwgdW5kZWZpbmVkKTogVCB8IHVuZGVmaW5lZCB7XG4gIHJldHVybiBhcnJheT8uW2FycmF5Lmxlbmd0aCAtIDFdO1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBZSxTQUFTQSxNQUFNQSxDQUFJQyxLQUErQixFQUFpQjtFQUNoRixPQUFPQSxLQUFLLGFBQUxBLEtBQUssdUJBQUxBLEtBQUssQ0FBR0EsS0FBSyxDQUFDQyxNQUFNLEdBQUcsQ0FBQyxDQUFDO0FBQ2xDIn0=